import { z } from 'zod';
import type { SchemaInput } from './schema-input.js';
import { dataLayerPayload, validateDataLayerPayload, type DataLayer } from './data-layer.js';

export const MAX_IMPORT_LINK_LENGTH = 12_000;
export const MAX_INLINE_IMPORT_BYTES = 256 * 1024;
export type ImportLinkState = { v: 1; l: ReturnType<typeof dataLayerPayload>[] } | { v: 1; d: string };
export interface ParsedImports { layers: DataLayer[]; draftId: string | null; failed: boolean }
const linkSchema = z.union([
  z.object({ v: z.literal(1), l: z.array(z.json()).max(100) }).strict(),
  z.object({ v: z.literal(1), d: z.string().min(1).max(100) }).strict(),
]);

export function parseImportLinkState(value: SchemaInput): ParsedImports {
  const invalid: ParsedImports = { layers: [], draftId: null, failed: true };
  if (new TextEncoder().encode(JSON.stringify(value)).byteLength > MAX_INLINE_IMPORT_BYTES) return invalid;
  const result = linkSchema.safeParse(value);
  if (!result.success) return invalid;
  if ('d' in result.data) return { layers: [], draftId: result.data.d, failed: false };
  const layers: DataLayer[] = [];
  for (const payload of result.data.l) {
    const validated = validateDataLayerPayload(payload);
    if (!validated.success) return invalid;
    const { layer, features } = validated.payload;
    if (layers.some((candidate) => candidate.id === layer.id)) return invalid;
    layers.push({ ...layer, features, saved: false });
  }
  return { layers, draftId: null, failed: false };
}
